<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Реестр отправлений</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Добавить письмо</li>
        </ol>
    </nav>

    <div class="letter-add_input">
        <div class="mb-4">
            <div class="form-label">Шаблон письма</div>
            <v-select class="select"
                      v-model="emailTemplate"
                      :items="emailTemplates"
                      @update:modelValue="onChangeTemplate"
                      @update:menu="$removeFocus"
                      @click:clear="$removeFocus"
                      @click:control="$removeFocus"
                      item-title="name"
                      item-value="id"
                      variant="outlined"
                      color="primary"
                      density="compact"
                      :clearable="isSelectValueSet(emailTemplate)">
                <template #no-data>
                    <v-list-item>
                        <span>Данные не найдены</span>
                    </v-list-item>
                </template>
            </v-select>
        </div>

        <div class="mb-4 input-field">
            <label class="form-label">Название письма</label>
            <input v-model="emailName" type="text" class="form-control" placeholder="">
        </div>

        <div class="mb-4 input-field">
            <label class="form-label">Тема письма</label>
            <input v-model="emailSubject" type="text" class="form-control" placeholder="">
        </div>

        <div class="v-select-input">
            <div class="mb-4">
                <div class="form-label">Отправитель</div>
                <v-select class="select"
                          v-model="sender"
                          :items="senders"
                          @update:modelValue="onChangeSender"
                          @update:menu="$removeFocus"
                          @click:clear="$removeFocus"
                          @click:control="$removeFocus"
                          item-title="name"
                          item-value="id"
                          variant="outlined"
                          color="primary"
                          density="compact"
                          :clearable="isSelectValueSet(sender)">
                    <template #no-data>
                        <v-list-item>
                            <span>Данные не найдены</span>
                        </v-list-item>
                    </template>
                </v-select>
            </div>
        </div>

        <div class="recievers">
            <div class="recievers__group">
                <div class="text-input-group">
                    <div style="position: relative;" class="mb-4 input-field">
                        <label class="form-label">Email адреса получателей</label>
                        <input ref="emailInput"
                               v-model="receiversEmails"
                               @keypress.enter="validateEmails"
                               type="text"
                               :class="emailError ? 'form-control input-error' : 'form-control'"
                               placeholder="Разделить через пробел"
                        >
                        <p class="text-error" v-if="emailError">{{ emailError }}</p>
                    </div>

                    <svg @click="validateEmails" class="email-add-btn" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 12L11 14L15 10M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 10.8181 20.7672 9.64778 20.3149 8.55585C19.8626 7.46392 19.1997 6.47177 18.364 5.63604C17.5282 4.80031 16.5361 4.13738 15.4442 3.68508C14.3522 3.23279 13.1819 3 12 3C10.8181 3 9.64778 3.23279 8.55585 3.68508C7.46392 4.13738 6.47177 4.80031 5.63604 5.63604C4.80031 6.47177 4.13738 7.46392 3.68508 8.55585C3.23279 9.64778 3 10.8181 3 12Z" stroke="#0678F4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>

                <div v-if="emails.length" class="letter-recievers-groups__selected-recievers mb-4">
                    <div class="selected-reciever"
                        v-for="(item, index) in emails">
                        {{ item }}
                        <svg @click="removeEmail(index, item.id)" class="selected-reciever__button" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_641_26163)">
                                <path d="M12 4L4 12" stroke="#242731" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M4 4L12 12" stroke="#242731" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_641_26163">
                                    <rect width="16" height="16" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
            </div>

            <div class="or-label">и/или</div>

            <div class="recievers__group">
                <div class="mb-4">
                    <div class="form-label">Группа получателей</div>
                    <v-select class="select"
                              v-model="receiversGroup"
                              :items="receiversGroups"
                              item-title="name"
                              item-value="id"
                              variant="outlined"
                              color="primary"
                              density="compact"
                              multiple
                              clearable
                              @update:modelValue="onChangeReceiversGroup"
                              @update:menu="$removeFocus"
                              @click:clear="$removeFocus"
                              @click:control="$removeFocus">
                        <template #no-data>
                            <v-list-item>
                                <span>Данные не найдены</span>
                            </v-list-item>
                        </template>
                    </v-select>
                </div>

                <div class="letter-recievers-groups__selected-recievers mb-4">
                    <div class="selected-reciever"
                         v-for="(item, index) in selectedReceiversGroups">
                        {{ item.name }}
                        <svg @click="removeGroup(index, item.id)" class="selected-reciever__button" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_641_26163)">
                                <path d="M12 4L4 12" stroke="#242731" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M4 4L12 12" stroke="#242731" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_641_26163">
                                    <rect width="16" height="16" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
            </div>
        </div>

        <!-- Способы отправки -->
        <div class="mailing__delivery-way">
            <div class="mb-4">
                <div class="input-label">Способ отправки</div>
                <v-select class="select"
                          v-model="deliveryWay"
                          :items="deliveryWays"
                          @update:modelValue="onChangeDeliveryWay"
                          @update:menu="$removeFocus"
                          @click:clear="$removeFocus"
                          @click:control="$removeFocus"
                          item-title="name"
                          item-value="id"
                          variant="outlined"
                          color="primary"
                          density="compact"
                          :clearable="isSelectValueSet(deliveryWay)">
                    <template #no-data>
                        <v-list-item>
                            <span>Данные не найдены</span>
                        </v-list-item>
                    </template>
                </v-select>
            </div>

            <!-- Описание способа отправки -->
            <div v-if="deliveryWayId" class="mb-4">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M12 9H12.01M11 12H12V16H13M3 12C3 13.1819 3.23279 14.3522 3.68508 15.4442C4.13738 16.5361 4.80031 17.5282 5.63604 18.364C6.47177 19.1997 7.46392 19.8626 8.55585 20.3149C9.64778 20.7672 10.8181 21 12 21C13.1819 21 14.3522 20.7672 15.4442 20.3149C16.5361 19.8626 17.5282 19.1997 18.364 18.364C19.1997 17.5282 19.8626 16.5361 20.3149 15.4442C20.7672 14.3522 21 13.1819 21 12C21 9.61305 20.0518 7.32387 18.364 5.63604C16.6761 3.94821 14.3869 3 12 3C9.61305 3 7.32387 3.94821 5.63604 5.63604C3.94821 7.32387 3 9.61305 3 12Z" stroke="#575F6E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    />
                </svg>
                <span class="text-info delivery-description">{{ deliveryDescription }}</span>
            </div>
            <!-- END Описание способа отправки -->

            <!-- Запланировать отправку -->
            <div v-if="deliveryWayId === schedule_sending_type" class="mb-4">
                <div class="input-label">Выберите дату и время</div>
                <div class="schedule mb-4">
                    <input v-model="datePlaned" :min="dateToday" class="form-control input-field__date" type="date">

                    <div class="me-3 input-field__date">
                        <input v-model="timePlaned" class="form-control" id="scheduleTime" type="time">
                    </div>
                </div>
            </div>
            <!-- END Запланировать отправку -->

            <!-- Еженедельно -->
            <div v-if="deliveryWayId === weekly_sending_type" class="mb-4">
                <div class="input-label">Выберите день недели и время</div>
                <div class="schedule mb-4">
                    <v-select class="select"
                              v-model="weekDay"
                              :items="weekDays"
                              @update:modelValue="onChangeWeekDay"
                              @update:menu="$removeFocus"
                              @click:clear="$removeFocus"
                              @click:control="$removeFocus"
                              item-title="name"
                              item-value="id"
                              variant="outlined"
                              color="primary"
                              density="compact"
                              clearable>
                        <template #no-data>
                            <v-list-item>
                                <span>Данные не найдены</span>
                            </v-list-item>
                        </template>
                    </v-select>

                    <div class="me-3 input-field__date">
                        <input v-model="timePlaned" class="form-control" id="scheduleTime" type="time">
                    </div>
                </div>
            </div>
            <!-- END Еженедельно -->

            <!-- Раз в несколько дней -->
            <div v-if="deliveryWayId === once_every_few_days_sending_type" class="mb-4">
                <div class="input-label">День недели</div>
                <div class="week-days">
                    <div v-for="day in weekDays" :key="day.id" class="form-check">
                        <input
                            :id="`day${day.id}`"
                            class="form-check-input"
                            type="checkbox"
                            :checked="this.selectedWeekDays.includes(day.id)"
                            @click="selectWeekDay(day)"
                        >
                        <label :for="`day${day.id}`" class="form-check__label">{{ day.name }}</label>
                    </div>
                </div>
                <div class="mb-4 input-field__date">
                    <label class="input-label">Время отправки</label>
                    <input v-model="timePlaned" class="form-control" id="scheduleTime" type="time">
                </div>
                <div class="mb-4">
                    <div class="schedule mb-4">
                        <div>
                            <label class="input-label">Дата начала рассылки</label>
                            <input v-model="mailing_date_start" @change="setDate($event)" :min="dateToday" class="form-control input-field__date" type="date">
                        </div>
                        <div>
                            <label class="input-label">Дата окончания рассылки</label>
                            <input v-model="mailing_date_end" id="mailing-date-end" :min="dateToday" class="form-control input-field__date" type="date">
                        </div>
                    </div>
                </div>
            </div>
            <!-- END Раз в несколько дней -->
        </div>
        <!-- END Способы отправки -->
    </div>

    <div id="leter-add-controls" class="letter_construct" style="display:block">
        <TinyMCE
            :key="editorIndex"
            :init="editorConfig"
            v-model="content"
        />

        <div class="letter-add-controls__control-buttons">
            <div class="left-side">
                <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить и выйти'" @btnClick="save"/>
                <a :href="route_back" id="cancelButton" class="btn btn-lg btn-outline-dark me-3">Отменить</a>
            </div>
        </div>
    </div>

    <Alert />

    <Transition name="fade">
        <NoRecieversModal v-if="showModal" @closeModal="closeModal" @save="save"/>
    </Transition>
</template>

<script>
import '/tinymce/tinymce.min.js';
import '/tinymce/icons/default/icons.min.js';
import '/tinymce/themes/silver/theme.min.js';
import '/tinymce/models/dom/model.min.js';
import TinyMCE from '@tinymce/tinymce-vue';
import axios from 'axios';
import Mailings from '../../../../models/Mailings/Mailings';
import NoRecieversModal from '../../../../modals/NoRecieversModal.vue';
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';
import ConfirmBtn from '../../../../elements/ConfirmBtn.vue';

export default {
    name: 'MailingAddComponent',
    props: {
        route_page_create: String,
        route_back: String,
        route_sender_list: String,
        route_create: String,
        route_templates_list: String,
        route_receivers_group_list: String,
        route_sending_types_list: String,
        route_weekdays_list: String,
        route_get: String,
        schedule_sending_type: Number,
        weekly_sending_type: Number,
        once_every_few_days_sending_type: Number,
        tinymce_keys: [Object]
    },
    components: {
        Alert,
        NoRecieversModal,
        TinyMCE,
        ConfirmBtn
    },
    data: function () {
        return {
            mailing: new Mailings({
                route_create: this.route_create,
                route_get: this.route_get
            }),
            document_base_url: '',
            content: '',
            emailName: '',
            emailSubject: '',

            sender: '',
            senders: [],

            emailTemplate: '',
            emailTemplates: [],

            receiversGroupId: [],
            selectedReceiversGroups: [],
            receiversGroup: [],
            receiversEmails: '',
            receiversGroups: [],

            deliveryWayId: '',
            deliveryWay: '',
            deliveryWays: [],

            weekDayId: [],
            weekDay: [],
            weekDays: [],
            checkedWeekDays: [],
            selectedWeekDays: [],

            alertMessage: '',

            datePlaned: '',
            timePlaned: '',

            deliveryDescription: '',

            mailing_date_start: '',
            mailing_date_end: '',

            mailingInfo: {},
            mailingId: null,

            dateToday: '',

            tinymceKeys: [
                this.tinymce_keys.primary,
                this.tinymce_keys.spare
            ],

            editorIndex: 0,
            keyIndex: null,
            editorInstance: null,

            emails: [],
            emailError: '',

            limit: 9999,

            showModal: false
        };
    },

    computed: {
        editorConfig() {
            return {
                language: 'ru',
                base_url: '/tinymce',
                suffix: '.min',
                plugins: [
                    'image', 'autoresize', 'code', 'media', 'autolink',
                    'table', 'lists', 'preview', 'link'
                ],
                toolbar1:
                    'newdocument | insertfile undo redo | bold italic underline strikethrough | ' +
                    'alignleft aligncenter alignright alignjustify | cut copy paste | numlist bullist | ' +
                    'tabulation outdent indent | image media | code | table styleselect formatselect fontselect fontsizeselect | ' +
                    'removeformat | preview',
                toolbar_mode: 'wrap',
                toolbar_sticky: false,
                min_height: 400,
                image_advtab: true,
                file_picker_types: 'file image media',
                default_link_target: '_blank',
                link_context_toolbar: true,
                relative_urls: false,
                remove_script_host: false,
                link_title: false,
                document_base_url: this.document_base_url,
                paste_as_text: false,
                paste_data_images: true,
                paste_merge_formats: false,
                valid_elements: '*[*]',
                paste_webkit_styles: 'all',
                content_style: 'body { max-width: 600px; margin: 0 auto; }',
                setup: (editor) => {
                    this.editorInstance = editor;

                    editor.on('init', () => {
                        if (this.mailingInfo.letter_body) {
                            editor.setContent(this.mailingInfo.letter_body);
                        }
                    });

                    editor.ui.registry.addButton('tabulation', {
                        icon: 'chevron-right',
                        tooltip: 'Отступ строки',
                        onAction: () => {
                            editor.execCommand('mceInsertContent', false, '&nbsp;&nbsp;&nbsp;&nbsp;');
                        }
                    });
                },
                images_upload_handler: this.uploadFunction,
            };
        }
    },

    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        async save() {
            await this.validateEmails();

            if (this.emailName === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Введите название письма' });
                this.toggleLoading();
                return;
            }

            if (this.emailSubject === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Укажите тему письма' });
                this.toggleLoading();
                return;
            }

            if (this.sender_id == null) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Укажите отправителя' });
                this.toggleLoading();
                return;
            }

            if (this.emailError) {
                this.toggleLoading();
                return;
            }

            if (this.deliveryWayId === this.schedule_sending_type || this.deliveryWayId === this.weekly_sending_type) {
                if (this.timePlaned == '') {
                    this.addAlert({ type: 'error', title: 'Ошибка', text: 'Укажите время отправки' });
                    this.toggleLoading();
                    return;
                }
            }

            let tinymce = document.querySelector('iframe');
            let editor = tinymce.contentDocument || tinymce.contentWindow.document;

            let createMailing = await axios.post(this.route_create,
                {
                    name: this.emailName,
                    type: this.deliveryWayId,
                    sender_id: this.sender_id,
                    letter_subject: this.emailSubject,
                    letter_group_id: !this.receiversGroupId.length ? null : this.receiversGroupId,
                    letter_template_id: this.emailTemplate.id,
                    emails: this.emails.join(' '),
                    day_week: this.weekDayId,
                    date_planed: this.datePlaned,
                    time_planed: this.timePlaned,
                    start: this.mailing_date_start,
                    end: this.mailing_date_end,
                    letter_body: `<div style="max-width: 600px; margin: 0 auto"${editor.getElementById('tinymce').innerHTML}</div>`,
                }
            );

            if (createMailing.data.status == 'ok') {
                window.location.href = this.route_back;
            } else {
                this.addAlert({ type: 'error', title: 'Ошибка', text: createMailing.data.message });
                this.toggleLoading();
            }

            if (!this.emails.length && !this.receiversEmails && !this.receiversGroupId.length) {
                localStorage.setItem('noRecievers', true);
            }
        },

        // Для клонирования письма
        async getMailing(id) {
            let item = await this.mailing.get(id);
            this.datePlaned = item.date_planed;
            this.timePlaned = item.time_planed;

            this.mailing_date_start = item.start;
            this.mailing_date_end = item.end;

            this.selectedWeekDays = item.day_week;

            if (this.selectedWeekDays != null) {
                this.checkedWeekDays = this.selectedWeekDays;
            }

            if (this.deliveryWay.id === this.weekly_sending_type) {
                setTimeout(() => {
                    this.weekDay = this.weekDays.find(day => day.id === this.checkedWeekDays.at(0));
                    this.weekDayId = [this.weekDay.id];
                }, 200);
            }
        },
        getMailingInfo() {
            if (localStorage.getItem('mailingId')) {
                this.mailingId = Number(localStorage.getItem('mailingId'));
                localStorage.removeItem('mailingId');
            }
            if (JSON.parse(localStorage.getItem('mailingInfo'))) {
                this.mailingInfo = JSON.parse(localStorage.getItem('mailingInfo'));
                localStorage.removeItem('mailingInfo');

                this.emailName = this.mailingInfo.name;
                this.emailSubject = this.mailingInfo.letter_subject;

                const receivers = this.mailingInfo.letter_groups;
                receivers.forEach(receiver => {
                    if (receiver.includes('@')) {
                        this.emails.push(receiver);
                    }
                });
            }
        },
        getWeekDaysList: async function () {
            let data = await axios.get(this.route_weekdays_list);
            this.weekDays = data.data;
        },
        getMailingsSendingTypesList: async function () {
            let data = await axios.get(this.route_sending_types_list);
            this.deliveryWays = data.data;
        },
        getReceiversGroups: async function () {
            let data = await axios.get(this.route_receivers_group_list, {
                params: {
                    limit: this.limit,
                }
            });
            this.receiversGroups = data.data.items;
        },
        getTemplates: async function () {
            let data = await axios.get(this.route_templates_list, {
                params: {
                    limit: this.limit,
                }
            });
            this.emailTemplates = data.data.items
        },
        getSenders: async function () {
            let senders = await axios.get(this.route_sender_list, {
                params: {
                    limit: this.limit,
                }
            });
            this.senders = senders.data.items;
        },
        onChangeSender: async function (id) {
            const sender = this.senders.find(item => item.id === id);
            this.sender_id = sender?.id;
            this.header = sender.header;
            this.footer = sender.footer;
            this.addHeaderAndFooter();
        },
        onChangeTemplate: async function (id) {
            const template = this.emailTemplates.find(item => item.id === id);
            if (template) {
                this.template_id = template.id;
                this.emailName = template.name;
                this.emailSubject = template.subject;
                this.sender = this.senders.find(obj => obj.id === template.sender_id).name;
                this.sender_id = template.sender_id;
                this.template = template.body;
                this.addTemplate();
            }
        },
        onChangeDeliveryWay: async function (id) {
            const deliveryWay = this.deliveryWays.find(item => item.id === id);
            this.datePlaned = '';
            this.timePlaned = '';
            this.weekDayId = '';
            this.weekDay = '';
            this.mailing_date_start = '';
            this.mailing_date_end = '';
            this.deliveryWayId = deliveryWay.id;
            this.deliveryDescription = deliveryWay.description;
            this.dateToday = new Date().toISOString().slice(0, 10);
        },
        onChangeWeekDay: async function (id) {
            this.weekDayId = [id];
        },
        onChangeReceiversGroup: async function (id) {
            this.receiversGroupId = id;
        },
        addHeaderAndFooter: function () {
            if (this.editorInstance.getContent().includes('<div id="header">') && this.editorInstance.getContent().includes('<div id="footer">')) {
                let header = '<div id="header">';
                let letterText = '<div id="letterText">'
                let footer = '<div id="footer">';
                function escapeRegExp(string) {
                    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                }

                let regexHeader = new RegExp(`${escapeRegExp(header)}(.*?)${escapeRegExp(letterText)}`, 's');
                let regexFooter = new RegExp(`${escapeRegExp(footer)}(.*)`, 's');
                let newStr = this.editorInstance.getContent()
                this.editorInstance.setContent(newStr.replace(regexHeader, `${header}${this.header}${escapeRegExp('</div><div id="letterText">')}`))

                newStr = this.editorInstance.getContent()

                this.editorInstance.setContent(newStr.replace(regexFooter, `${footer}${this.footer}`))
            }
        },
        addTemplate: function () {
            this.editorInstance.setContent(this.template)
        },
        uploadFunction:  function(blobInfo, success, failure) {
            return new Promise((resolve, reject) => {
                const FormRequest = new FormData();
                FormRequest.append('image', blobInfo.blob());
                let imgUrl = null;
                axios.post('/technical/letter-constructor/upload', FormRequest).then((res) => {
                    if(res.data.status == 'ok') {
                        imgUrl = res.data.url;
                        resolve(imgUrl);
                    }
                });
            })
        },
        selectWeekDay: function (day) {
            let index = this.checkedWeekDays.indexOf(day.id);
            if (index !== -1) {
                this.checkedWeekDays.splice(index, 1)
            } else {
                this.checkedWeekDays.push(day.id)
            }
            this.weekDayId = this.checkedWeekDays;
        },
        setDate: async function(e) {
            const selectedDateFrom = new Date(e.target.value);
            selectedDateFrom.setDate(selectedDateFrom.getDate() + 1);
            const $date = selectedDateFrom.toISOString().slice(0, 10);
            document.getElementById('mailing-date-end').setAttribute('min', $date);
            document.getElementById('mailing-date-end').value = '';
        },
        async validateEmails() {
            if (!this.receiversEmails) return;
            const emailPattern = /^(?!.*\.\.)[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;
            const emails = this.receiversEmails.trim().split(/\s+/);
            let invalidEmails = [];

            emails.forEach(email => {
                if (emailPattern.test(email) && !this.emails.includes(email)) {
                    this.emails.push(email);
                } else {
                    invalidEmails.push(email);
                    this.emailError = 'Проверьте, что адреса соответствуют формату (a@a.ru), разделены пробелом, не содержат кириллицы и запрещённых символов ( , : ! и т.п), а также не повторяются.';
                    this.$refs.emailInput.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                    });
                }
            });
            this.receiversEmails = invalidEmails.join(' ');
            if (!this.receiversEmails) this.emailError = '';
        },
        removeEmail: async function (index) {
            this.emails.splice(index, 1);
        },
        removeGroup: function (index) {
            this.selectedReceiversGroups.splice(index, 1);
        },
        closeModal() {
            this.showModal = false;
        },
        isSelectValueSet(value) {
            if(value === ''){
                return false;
            }
            return true;
        }
    },
    watch: {
        receiversEmails: {
            handler(newValue) {
                if (newValue === '') this.emailError = '';
            }
        },
        emailTemplate(newValue) {
            if (newValue === null) this.emailTemplate = '';
        },
        sender(newValue) {
            if (newValue === null) this.sender = '';
        },
        deliveryWay(newValue) {
            if (newValue === null) this.deliveryWay = '';
        },
        senders(newValue) {
            if (newValue && this.mailingInfo.name) {
                this.sender = newValue.find(sender => sender.name === this.mailingInfo.letter_sender_name);
                this.sender_id = this.sender.id;
            }
        },
        deliveryWays(newValue) {
            if (newValue && this.mailingInfo.name) {
                this.deliveryWay = newValue.find(deliveryWay => deliveryWay.name === this.mailingInfo.sending_type);
                this.deliveryWayId = this.deliveryWay.id;
            }
        },
        receiversGroups(newValue) {
            if (newValue && this.mailingInfo.name) {
                this.mailingInfo.letter_groups.forEach(group => {
                    if (!group.includes('@')) {
                        this.receiversGroup.push(
                            newValue.find(receiversGroup => receiversGroup.name === group)
                        );
                        this.receiversGroupId.push(
                            newValue.find(receiversGroup => receiversGroup.name === group).id
                        );
                    }
                });
            }
        },
    },
    mounted () {
        this.getTemplates();
        this.getSenders();
        this.getReceiversGroups();
        this.getMailingsSendingTypesList();
        this.getWeekDaysList();
        this.getMailingInfo();
        if (this.mailingId) {
            this.getMailing(this.mailingId);
        }
    }
}
</script>

<style scoped lang="scss">

.page-label {
    font-size: 18px;
    font-weight: 600;
}
.or-label {
    font-weight: 500;
    padding-top: 24px;
}
.input-label {
    font-size: 14px;
    font-weight: 600;
}
.text-input-group {
    display: flex;
    flex-direction: row;
    gap: 60px;
}
.input-field {
    width: 400px;
    &__date {
        width: 300px;
    }
}
.schedule {
    display: flex;
    flex-direction: row;
    gap: 24px;
}
.v-select-input {
    display: flex;
    flex-direction: row;
    gap: 30px;
}
.v-select {
    width: 400px;
}
.letter_construct .pattern_container {
    display: block;
    position: absolute;
    top: 30px;
    left: 260px;
    background-color: #fff;
    border: 1px solid #D1D1D1;
    border-radius: 5px;
}

.letter_construct .pattern_inner {
    line-height: 38px;
    padding: 0 24px;
    cursor: pointer;
    border-bottom: 1px solid #ddd;
}

.letter_construct .pattern_inner:hover {
    background-color: #1aa2fd;
    color: #fff;
}

.letter_construct .editor_container {
    position: relative;
}

.letter-add-controls {
    &__letter-buttons {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 0px 0px 20px 0px;
    }
    &__control-buttons {
        display: flex;
        flex-direction: row;
        margin: 20px 0px 20px 0px;
        gap: 18px;
        justify-content: space-between;
    }
}

.blue {
    color: #0678F4;
    font-size: 14px;
}

.black {
    color: black;
    font-size: 14px;
}

.left-side {
    display: flex;
    flex-direction: row;
    flex: 3;
}

.right-side {
    display: flex;
    flex-direction: row;
    flex: 2;
    justify-content: flex-end
}

#saveButton {
    padding: 0px 72px;
}

#previewButton {
    padding: 0px 30px;
}

#HTMLButton {
    padding: 0px 30px;
}

#cancelButton {
    padding: 0px 42px;
}

.letter-recievers-groups {
    &__recievers {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        gap: 60px;
    }
    &__selected-recievers {
        display: flex;
        max-height: 130px;
        overflow-y: auto;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 12px;
    }
    &__control-buttons {
        display: flex;
        flex-direction: row;
        gap: 4px;
    }
}

.selected-reciever {
    border: 1px solid #EAEEF4;
    border-radius: 5px;
    padding: 5px 8px;
    &__button {
        cursor: pointer;
    }
    &__button:hover {
        path {
            stroke: red;
            transition: stroke 0.15s ease;
        }
    }
}

.week-days {
    margin: 0px 0px 20px 0px;
    display: flex;
    flex-direction: row;
    gap: 12px;
}

.form-check__label {
    vertical-align: sub;
    cursor: pointer;
}

.vs--disabled > :first-child {
    background-color: #D1D1D1;
    cursor: not-allowed;
}

.delivery-description {
    font-size: 16px;
    vertical-align: middle;
    margin-left: 5px;
}

.input-error {
    border: 1px solid #E33535;
}

.text-error {
    font-size: 12px;
    font-weight: 400;
    margin: 0;
    color: #E33535;
}

.email-add-btn {
    align-self: center;
    margin-left: -46px;
    cursor: pointer;
}

.recievers {
    display: flex;
    gap: 46px;
    &__group {
        display: flex;
        flex-direction: column;
        max-width: 450px;
    }
}
</style>
